<div class="outer-container">

  <lib-title-bar
    [crumbs]="[{ 'label': 'Users' , 'link': '/dashboard/users' }, { 'label': pageTitle }]">
  </lib-title-bar>

  <div class="details-container">
    @if (!user) {
      <lib-busy-indicator>
      </lib-busy-indicator>
    }
    @if (user) {
      <form [formGroup]="userForm" [libVituForm]="userForm" (libVituFormSubmit)="onSubmit()">
        <div class="form-inner-container">
          <lib-vitu-form-field-input
            class="field"
            [formGroup]="userForm"
            formFieldName="firstName"
            label="First Name"
            [disabled]="viewOnly">
          </lib-vitu-form-field-input>
          <lib-vitu-form-field-input
            class="field"
            [formGroup]="userForm"
            formFieldName="lastName"
            label="Last Name"
            [disabled]="viewOnly">
          </lib-vitu-form-field-input>
          <lib-vitu-form-field-input
            class="field"
            id="emailAddress"
            [formGroup]="userForm"
            formFieldName="email"
            type="email"
            label="Email Address"
            [disabled]="viewOnly">
          </lib-vitu-form-field-input>
          <lib-vitu-form-field-select
            class="field"
            [formGroup]="userForm"
            formFieldName="roleIds"
            multiple
            label="Role(s)"
            [options]="groupedRoleList"
            optionLabelKey="name"
            optionValueKey="id"
            [groups]="roleGroups"
            [disabled]="viewOnly">
          </lib-vitu-form-field-select>
          @if (!isCreate) {
            <div class="actions-line">
              <lib-vitu-form-field-switch
                formControlName="isLockedOut"
                label="Locked"
                [disableControl]="viewOnly">
              </lib-vitu-form-field-switch>
              <div class="action-buttons">
                @if (hasDeleteUserPermission) {
                  <lib-action-button
                    id="deleteUserButton"
                    class="action-button"
                    label="Delete User"
                    fontImage="far fa-trash fa-bg"
                    [kind]="ActionButtonKind.ALERT"
                    [disabled]="loading || !user || !currentUser || (user.id === currentUser.id)"
                    (click)="onClickDelete()">
                  </lib-action-button>
                }
                @if (hasResetPasswordPermission) {
                  <lib-action-button
                    id="resetPasswordButton"
                    class="action-button"
                    label="Reset Password"
                    [kind]="ActionButtonKind.SECONDARY"
                    [disabled]="loading"
                    (click)="onClickResetPassword()">
                  </lib-action-button>
                }
              </div>
            </div>
          }
        </div>
        <lib-vitu-form-buttons>
          <lib-vitu-form-abort-button
            (onAbort)="onClickBack()">
          </lib-vitu-form-abort-button>
          @if (isCreate || hasUpdateUserPermission) {
            <lib-vitu-form-submit-button
              [label]="submitButtonText"
              [neverDisable]="isCreate">
            </lib-vitu-form-submit-button>
          }
        </lib-vitu-form-buttons>
      </form>
    }
  </div>

</div>



